import type { DbSubmissionBlock } from '@domain/schemas/block.schema';
import type { EndorsementResponse } from '@domain/schemas/contract.schema';
import type { EndorsementData, EntityData } from '@domain/types/entity';
import { get } from 'lodash-es';

const isEndorsement = (entity?: EntityData | EndorsementData | EndorsementResponse): entity is EndorsementData => {
  if (!entity) {
    return false;
  }

  const pk = entity.pk;
  const sk = entity.sk;

  const normalizedPk = pk.replace(/^tenant#[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}#/i, '');

  return normalizedPk.startsWith('submissions#') && sk.startsWith('endorsements#');
};

export const getBlocksExcludedFromPreview = (entity?: EntityData | EndorsementData | EndorsementResponse): string[] =>
  get(entity, 'summary.blocksExcludedFromPreview', [] as string[]);

export const isExcludedFromEndorsementPreview = (
  block: Pick<DbSubmissionBlock, 'id'>,
  entity?: EntityData | EndorsementData | EndorsementResponse,
): boolean => {
  if (!isEndorsement(entity)) {
    return false;
  }

  return getBlocksExcludedFromPreview(entity).includes(block.id);
};
